var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLiveTrafficDisabledVehicle = function SvgLiveTrafficDisabledVehicle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D77A2D",
    d: "M12.005 22.089c5.525 0 10.004-4.48 10.004-10.005S17.529 2.08 12.005 2.08C6.479 2.08 2 6.559 2 12.084 2 17.61 6.48 22.09 12.005 22.09"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.45 8.127H8.129l-1.456 3.546v4.94h1.822v-1.304h2.974z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D77A2D",
    d: "M12.147 11.343H8.262l.714-2.046h2.984zM9.065 13.71a.67.67 0 1 0 0-1.34.67.67 0 0 0 0 1.34"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.656 8.127h4.117l1.465 3.546v4.94h-1.822v-1.304h-2.974z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D77A2D",
    d: "M10.334 11.343h4.314l-.714-2.046h-3.27zM13.845 13.71a.67.67 0 1 0 0-1.34.67.67 0 0 0 0 1.34"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D77A2D",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.71,
    d: "M14.898 10.173a2.43 2.43 0 1 0 0-4.86 2.43 2.43 0 0 0 0 4.86Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.898 8.27a.223.223 0 0 0 .224-.232V6.474c0-.098-.063-.187-.143-.214a.219.219 0 0 0-.304.205v1.573c0 .134.098.232.223.232M14.907 8.591c-.187 0-.33.134-.33.313 0 .188.134.33.313.33a.326.326 0 0 0 .33-.312c0-.179-.134-.33-.313-.33"
  })));
};
export default SvgLiveTrafficDisabledVehicle;